import * as React from "react";

type Props<T> = {
    source: Array<T> | ReadonlyArray<T>;
    children: (item: T, index: number) => React.ReactElement;
}

/**
 * A component that takes a source list and calls the mapping child function for each item.
 */
export function Repeater<T>(props: Props<T>) {
    const children = props.source.slice().reduce((state, item, index) => {
        const newChildren = props.children(item, index);

        if (Array.isArray(newChildren))
            // Flatten the array
            return [...state, ...newChildren];

        return [...state, newChildren];
    }, [] as React.ReactElement[]);

    return <React.Fragment>{children}</React.Fragment>;
}
